/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';

import {
  CurrentUserType,
  UserLanguageType,
  UserLinkType,
} from '@api/types';
import { DEFAULTS } from '@constants/defaults';
import { LOCAL_STORAGE_KEYS } from '@constants/local-storage-constants';
import { setLocale } from '@/i18n';

type UserStoreStateType = {
  data: CurrentUserType;
  initialized: boolean;
};

const initialState = (): UserStoreStateType => ({
  data: {
    id: null,
    firstName: '',
    lastName: '',
    email: '',
    image: null,
    headline: '',
    location: '',
    locale: localStorage.getItem(LOCAL_STORAGE_KEYS.LOCALE) || DEFAULTS.USER.LOCALE,
    timezoneCode: DEFAULTS.USER.TIMEZONE_CODE,
    disablePromotion: DEFAULTS.USER.DISABLE_PROMOTION,
    languages: [],
    links: [],
    ssoRequired: false,
  },
  initialized: false,
});

export const useUserStore = defineStore({
  id: 'user',
  state: initialState,
  getters: {
    ssoRequired: (state) => state.data.ssoRequired,
  },
  actions: {
    $reset() {
      Object.assign(this, initialState());
    },
    set(data: CurrentUserType): void {
      Object.keys(data).forEach(async (key) => {
        this.data[key] = data[key];
      });
      setLocale(this.data.locale);
      this.initialized = true;
    },
    setImage(image: string): void {
      this.data.image = !image ? null : image;
    },
    addLink(data: UserLinkType): void {
      this.data.links.push(data);
    },
    removeLink(userLinkId: number): void {
      const index = this.data.links.findIndex((elem) => elem.id === userLinkId);
      if (index < 0) return;
      this.data.links.splice(index, 1);
    },
    addLanguage(data: UserLanguageType): void {
      this.data.languages.push(data);
    },
    removeLanguage(userLanguageId: number): void {
      const index = this.data.languages.findIndex(
        (elem) => elem.id === userLanguageId,
      );
      if (index < 0) return;
      this.data.languages.splice(index, 1);
    },
  },
});
